import { useState } from 'react'
import { Helmet } from 'react-helmet'
import DataTableController from 'components/common/dataTable/dataTableController'
import {
  InventoryDataTable,
  columns,
  InventoryFilterForm,
} from 'components/inventory'
import { usePageAccess, useQuery } from 'hooks'
import { downloadInventory, importInventory } from 'utils/api/inventoryApi'
import toast from 'react-hot-toast'
import { FILTER_FIELD_INVENTORY } from 'components/inventory/inventoryFilterForm'
import { filterEmptyValues } from 'utils/helpers'
import { AxiosError } from 'axios'

const Inventory = () => {
  const [showFilter, setShowFilter] = useState(false)
  const [selectedColumns, setSelectedColumns] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const { isEditor } = usePageAccess()

  const { getQuery } = useQuery()

  const toggleFilterForm = () => {
    setShowFilter(!showFilter)
  }

  // Will handle the file export funtionality with toast
  const handleExport = async () => {
    const filters = getQuery(FILTER_FIELD_INVENTORY)

    // if not filters found in URL
    if (!filters) {
      return toast.error('Filters are required to export data!', {
        duration: 3000,
      })
    }

    // filtering empty values and keys of filter
    const pricingFilter = filterEmptyValues(filters)

    // if filters are present with empty values
    if (Object.keys(pricingFilter).length <= 0) {
      return toast.error('Please select at least on filter to export data!', {
        duration: 3000,
      })
    }

    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    try {
      await downloadInventory({ filters: pricingFilter })
      toast.success('File will be sent to you in email!', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: loadingToast,
            duration: 3000,
          })
        }
      }
      toast.error('Failed to export Inventory Data.', {
        id: loadingToast,
        duration: 3000,
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>ORMS Inventory</title>
      </Helmet>
      {/* Table Header Controlls : Import | Export | column manager | search */}
      <DataTableController
        isEditor={isEditor}
        columns={columns}
        handleFilter={toggleFilterForm}
        showFilter={showFilter}
        handleExport={handleExport}
        handleImport={importInventory}
        activeColumnKey="inventory"
        defaultSelectedColumns={selectedColumns}
        placeholder="Search by barcode and store id"
        loading={loading}
      />
      {showFilter ? (
        <InventoryFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <InventoryDataTable
          loading={loading}
          setLoading={setLoading}
          setSelectedColumns={setSelectedColumns}
          isEditor={isEditor}
        />
      )}
    </>
  )
}

export default Inventory
